/**
 * Import your main React Components / Containers here below
 */

// Define Application as a React Component
import React from "react";
//import {ApiContext} from "bnppf-marvin-js";
//import t from './helpers/I18n'
import {Route, Switch, Redirect, withRouter } from "react-router-dom";
//import {SomeContextStoreProvider} from "./contexts/some-context";
//import SomeOtherComponent from "./components/_old/some-other-component";
//import SomeStaticComponent from "./components/some-static-component";
import PropTypes from "prop-types";

//import BreakPointProvider from './contexts/breaking-point'
import StoryBook from "./storybook-component";

//STEP 0 Welcome
import ProductPage from "steps/welcome-step/product-page";
import WelcomeStep from "steps/welcome-step/welcome-step";
import IntroStep from "steps/welcome-step/intro-step";
import IntroLegal from "steps/welcome-step/intro-legal";
import IntroIdStep from "./components/steps/id-step/intro-id";
import ProIntro from "./components/steps/pro-info/intro-pro";
import Error404 from "./components/steps/404";
import Error500 from "./components/steps/500";

//STEP 1 Personal Info
import Steps from "steps/steps"

//STEP 2 Legal Info
import LegalSteps from "./components/steps/legal-steps";

//STEP 3 Pro Info
import ProSteps from "./components/steps/pro-steps";
//import Nace from "./nace";

import PreConfirmation from "./components/steps/pro-info/pre-confirmation";
import Confirmation from "./components/steps/pro-info/confirmation";
import XeriusConsent from "./components/steps/pro-info/xerius-consent";
import getStep from "./helpers/getStep";

const lang = localStorage.getItem('language').toLocaleLowerCase()



export class ReactApplication extends React.Component {

    constructor(props) {
        super(props);
        this.devRoute = ":id"
        this.base = '/:locale(nl|fr)?'
        this.handlePopStateEvent = this.handlePopStateEvent.bind(this);
    }

    

    componentDidMount() {
        document.title = localStorage.getItem('language') === "FR"
            ? "Compte Pro Gratuit - Devenir indépendant(e) - Hello bank!"
            : "Gratis Pro rekening - Zelfstandige worden - Hello bank!"

        window.addEventListener('popstate', (event) => {
            this.handlePopStateEvent(event);
        });

    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopStateEvent);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (this.props.history.entries[this.props.history.entries.length-1].key === this.props.location.key) {
                window.history.pushState(this.props.location, null, null);
            }
        }
    }

    handlePopStateEvent() {
        this.props.history.goBack();
    }


    render() {
        return (
            <Switch>
                <Route exact path={this.base} component={ProductPage} />

                <Route path={`${this.base}/404`} component={Error404} />
                <Route path={`${this.base}/500`} component={Error500} />

                <Route path={`${this.base}/welcome`} component={WelcomeStep} />
                {/* <Route path={`/reources`} component={WelcomeStep} /> */}
                
                {/* step 1 : personal info */}
                <Route  path={`${this.base}/intro`} component={IntroStep} />
                <Route path={`${this.base}/steps/${this.devRoute}`} component={Steps} ><Steps history={this.props.history} /></Route>
                
                {/* step 2 : Legal info */}
                <Route path={`${this.base}/intro-legal`} component={IntroLegal} />
                <Route path={`${this.base}/legal-steps/${this.devRoute}`}><LegalSteps history={this.props.history} /></Route>

                {/* step ID card */}
                <Route path={`${this.base}/id-card`} component={IntroIdStep} />

                {/* <Route path={`${this.base}/legal-steps/${this.devRoute}`}><LegalSteps history={this.props.history} /></Route> */}

                {/* step pro steps */}
                <Route path={`${this.base}/pro-info`} component={ProIntro} />
                <Route path={`${this.base}/pro-steps/${this.devRoute}`}><ProSteps history={this.props.history} /></Route>

                {/* confirmation step */}
                <Route path={`${this.base}/pre-confirmation`} component={PreConfirmation} />
                <Route path={`${this.base}/xerius-consent`} component={XeriusConsent} />
                <Route path={`${this.base}/confirmation`} component={Confirmation} />

                <Route path={`${this.base}/storybook`} component={StoryBook} />
                <Route path={`/check`}><div>Check OK </div></Route>

                <Redirect to={`/${lang}/404`} />
            </Switch>
        )
    }
}

ReactApplication.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

// export const ReactApplicationComponent = withRouter(ReactApplication);
export const ReactApplicationComponent = ReactApplication;